var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/clientDetails',["require", "exports", "common/viewmodelbase", "models/portal", "areas/informationrequest/models/bindable", "models/account", 'durandal/app', "areas/informationrequest/service/informationrequest-service", "areas/informationrequest/viewmodels/hmrcAPIInfo", "services/navigator", "areas/informationrequest/service/sectionapimappings", "areas/informationrequest/service/toastDCService", "common/string"], function (require, exports, common, Portal, VM, Account, app, service, hmrcAPI, Navigator, sectionapimappings, toastService, String) {
    "use strict";
    var InformationRequestViewModel1 = (function (_super) {
        __extends(InformationRequestViewModel1, _super);
        // #region ctor
        function InformationRequestViewModel1() {
            _super.call(this);
            this.sections = new Array();
            this.statuses = new Array();
            this.clientInfo = new VM.InformationRequest();
            this.sectionComments = new Array();
            this.selectedSection = new VM.BaseSectionVM();
            this.hasInformationReq = ko.observable(false);
            this.hasHmrcAuthorisation = ko.observable(false);
            this.displayOverlay = ko.observable(false);
            this.displayLoading = ko.observable(false);
            this.displayProcessOverlay = ko.observable(false);
            this.useCloudEvents = ko.observable(false);
            this.displayCommitStatus = ko.observable(true);
            this.displayMessageFeatureInDDR = ko.observable(false);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.lastUpdatedHmrcInfo = ko.observable("");
            this.lastReturnModifiedDate = ko.observable("");
            this.commitStatus = ko.observable("");
            this.commitToTaxToastMessage = ko.observable("");
            this.commitState = ko.observable("");
            this.checkedSources = ko.observable(0);
            this.enableCommitToTaxButton = ko.observable(false);
            this.statuses = [];
            this.statuses.push("");
            this.statuses.push("Approved");
            this.statuses.push("Incomplete");
            this.statuses.push("Not Applicable");
            ko.track(this, ["sections", "statuses", "clientInfo", "clientGuid", "sectionComments", "newMessage", "dtaInfo", "hmrcInformation", "currentYearHeader"]);
            this.informationrequestService = new service.InformationRequestService();
            this.hmrcInfoModel = new hmrcAPI.hmrcAPIInfoViewModel();
            this.toastDCService = new toastService.ToastDCService();
            this.noValueLabel = "N/A";
            this.exceptionsMessage = "";
            this.displayLoading(false);
            this.enableCommitToTaxButton(false);
            window.onbeforeunload = function (e) {
                console.log('da');
            };
        }
        // #endregion ctor
        InformationRequestViewModel1.prototype.onActivated = function (context) {
            this.clientGuid = context.queryString.clientGuid;
            this.taxYear = context.queryString.taxYear;
            var parameter = context.path.split('/');
            var calledFromTools = parameter[1] != null ? JSON.parse(parameter[1]) : null;
            this.isMortgageRepostion = this.taxYear >= 2021;
            this.loadData();
            this.spliceLastBreadcrumbs(context, calledFromTools);
        };
        InformationRequestViewModel1.prototype.createiServeCrumb = function () {
            if (this.breadCrumb.items.length === 0) {
                this.addiServeCrumbToBreadcrumbItems();
            }
        };
        InformationRequestViewModel1.prototype.addiServeCrumbToBreadcrumbItems = function () {
            var crumb = Portal.BreadCrumbItem.from(this.clientInfo.ClientName);
            //crumb.clickAction = this.onBeforelaod();
            this.breadCrumb.items.push(crumb);
        };
        InformationRequestViewModel1.prototype.spliceLastBreadcrumbs = function (context, calledFromTools) {
            if (this.breadCrumb.items.length > 1) {
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 2, 2);
                }
            }
            else {
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                    this.addiServeCrumbToBreadcrumbItems();
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
            }
        };
        InformationRequestViewModel1.prototype.rootClicked = function (section, vm) {
            if (section.children.length > 0) {
                section.expanded(!section.expanded());
                if (section.expanded() && section.hasNotification())
                    this.informationrequestService.clearNotification(section.clientGuid, section.taxYear, section.sectionGuid).then(function (response) {
                        section.hasNotification(false);
                    });
            }
            $('#childBenefitDateCeased').kendoDatePicker({ format: 'dd/MM/yyyy' });
        };
        InformationRequestViewModel1.prototype.mouseOverRoot = function (section) {
            section.mouseOver(true);
        };
        InformationRequestViewModel1.prototype.mouseOutRoot = function (section) {
            section.mouseOver(false);
        };
        InformationRequestViewModel1.prototype.enclosedClick = function (section, event) {
            section.enclosedPressed(!section.enclosedPressed());
        };
        InformationRequestViewModel1.prototype.geTime = function (date) {
            return date != null ? date.getTime() : 0;
        };
        InformationRequestViewModel1.prototype.hasChanges = function () {
            console.log("Da");
            Navigator.navigateTo("digitalTax", "digitalTax", "/digitalTax", null);
        };
        InformationRequestViewModel1.prototype.showComments = function (section, event) {
            var _this = this;
            this.sectionComments.removeAll();
            var sectionGuid = section.sectionGuid;
            this.informationrequestService.getComments(sectionGuid).then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    var comment = response[i];
                    _this.sectionComments.push(comment);
                }
                section.commentsCount(_this.sectionComments.length);
                var objDiv = document.getElementById("bodyDivId");
                objDiv.scrollTop = objDiv.scrollHeight;
            }).fail(function (error) { return console.log(error); });
            var self = this;
            self.newMessage = '';
            $("#messagesModalId").modal("show");
            self.selectedSection = section;
        };
        InformationRequestViewModel1.prototype.showAttachments = function (section, event) {
            var self = this;
            self.selectedSection = section;
            app.showDialog("areas/informationrequest/viewmodels/viewattachments", self);
        };
        InformationRequestViewModel1.prototype.showOkDialog = function (message) {
            $("#messageDialogOkId").text(message);
            $("#dialogOkId").modal("show");
        };
        InformationRequestViewModel1.prototype.showCommitDialog = function () {
            if (this.commitStatus() == "Sending in progress") {
                this.toastDCService.constructDCToast('fail', "An earlier sending of data to CCH Central is in progress. Please wait for this to complete before trying again.");
            }
            else if (!this.enableCommitToTaxButton()) {
                this.toastDCService.constructDCToast('fail', "Please select some data to use in the tax return.");
            }
            else if (this.commitStatus() == "Retrieving tax data") {
                this.toastDCService.constructDCToast('fail', "We are in the process of retrieving this year's Tax Return data from CCH Central which may take some time. Please try again later.");
            }
            else {
                $("#dialogConfirmCommitId").modal("show");
            }
        };
        InformationRequestViewModel1.prototype.closeDetails = function (section, event) {
            $("#detailModalId").modal("hide");
        };
        InformationRequestViewModel1.prototype.sendMessage = function (section, event) {
            var self = this;
            if ($.trim(self.newMessage).length > 0) {
                var newComment = new VM.Comment();
                newComment.message = self.newMessage;
                newComment.date = new Date(Date.now());
                newComment.userName = Account.Principal.current.loginName;
                newComment.sectionGuid = section.selectedSection.sectionGuid;
                newComment.commentGuid = VM.Guid.newGuid();
            }
            self.sectionComments.push(newComment);
            self.newMessage = '';
            section.selectedSection.commentsCount(section.selectedSection.commentsCount() + 1);
            var bodyDivElement = document.getElementById('bodyDivId');
            bodyDivElement.scrollTop = bodyDivElement.scrollHeight;
            self.saveComment(newComment);
        };
        InformationRequestViewModel1.prototype.saveComment = function (newComment) {
            var self = this;
            var id = self.clientGuid;
            var taxYear = self.taxYear;
            this.informationrequestService.SaveCommentAync(id, taxYear, newComment);
        };
        InformationRequestViewModel1.prototype.closeMessages = function (section, event) {
            var self = this;
            if (self.newMessage != '')
                $("#dialogConfirmId").modal("show");
            else
                $("#messagesModalId").modal("hide");
        };
        InformationRequestViewModel1.prototype.closeDialog = function () {
            $("#dialogConfirmId").modal("hide");
            $("#messagesModalId").modal("hide");
            $("#dialogOkId").modal("hide");
            $('#dialogConfirmSaveId').modal("hide");
            $("#dialogConfirmCommitId").modal("hide");
        };
        InformationRequestViewModel1.prototype.keepOpen = function (event) {
            $("#dialogConfirmId").modal("hide");
        };
        InformationRequestViewModel1.prototype.saveChangesWithToast = function () {
            this.saveChanges(true);
        };
        InformationRequestViewModel1.prototype.saveChanges = function (silent) {
            var _this = this;
            if (!this.displayLoading())
                this.displayOverlay(true);
            //User Story 190929:: commenting due to ui no and NI number check is not required
            //if (this.hmrcInfoModel.hasInvalidSpouseFields()) {
            //    this.showOkDialog("Invalid or missing the spouse/civil partner details. Please review the data and try again.");
            //    this.displayOverlay(false);
            //    return;
            //}
            var sendRequest = false;
            var hasChangedSpouse = false;
            if (silent)
                sendRequest = true;
            var self = this;
            if (this.hmrcInfoModel.hasChangedSpouseInfo(this.clientInfo.Spouse)) {
                sendRequest = true;
                self.clientInfo.Spouse = this.hmrcInfoModel.getHmrcSpouseInfo();
                hasChangedSpouse = true;
            }
            var infoRequest = new VM.InformationRequest();
            infoRequest = ko.toJS(self.clientInfo);
            infoRequest.Sections = [];
            var infoRequest2 = new VM.InformationRequest();
            infoRequest.Sections = this.constructInfoRequestSections(self.clientInfo.Sections, sendRequest);
            infoRequest.Spouse = infoRequest.SpouseFromPT;
            self.clientInfo.Sections = infoRequest.Sections;
            if (sendRequest) {
                this.informationrequestService.SaveClientDetails(infoRequest).then(function () {
                    self.displayOverlay(false);
                    _this.toastDCService.constructDCToast('success', "Saved");
                    _this.removeClientNotifications(self.clientInfo.Sections);
                    var old = Object.create(self.clientInfo.Sections);
                    self.oldSections = ko.toJS(old);
                }).fail(function () {
                    _this.toastDCService.constructDCToast('fail', "Error, not saved");
                });
            }
            else {
                self.displayOverlay(false);
            }
        };
        InformationRequestViewModel1.prototype.removeClientNotifications = function (infoRequestSections) {
            if (infoRequestSections.length > 0)
                for (var i = 0; i < infoRequestSections.length; i++) {
                    var childSection = infoRequestSections[i].hasClientNotification = false;
                    this.removeClientNotifications(infoRequestSections[i].children);
                }
        };
        InformationRequestViewModel1.prototype.constructInfoRequestSections = function (infoRequestSections, sendRequest) {
            var sections = [];
            if (infoRequestSections.length > 0) {
                for (var i = 0; i < infoRequestSections.length; i++) {
                    var childSection = this.evaluateStatus(infoRequestSections[i]);
                    childSection.UnmaskAmount();
                    if (this.sectionChanged(childSection)) {
                        if (childSection.children.length == 0)
                            childSection.hasClientNotification = true;
                        sendRequest = true;
                    }
                    var children = this.constructInfoRequestSections(childSection.children, sendRequest);
                    childSection.children = children;
                    //check if all levels of sections are approved 
                    if (childSection.children != null && childSection.children.length > 0) {
                        var approvedChildSections = childSection.children.filter(function (e) {
                            return e.status == "Approved";
                        });
                        var notApplicableChildSections = childSection.children.filter(function (e) {
                            return e.status == "Not Applicable";
                        });
                        var childSectionsCount = childSection.children.length;
                        var approvedChildSectionsCount = approvedChildSections.length;
                        var notApplicableChildSectionsCount = notApplicableChildSections.length;
                        if (approvedChildSectionsCount == childSectionsCount || (approvedChildSectionsCount + notApplicableChildSectionsCount == childSectionsCount)) {
                            if (notApplicableChildSectionsCount == childSectionsCount) {
                                childSection.approved = 3;
                                childSection.completeFromWeb(false);
                                childSection.status = "";
                            }
                            else {
                                childSection.approved = 1;
                                childSection.completeFromWeb(true);
                                childSection.status = "Approved";
                            }
                        }
                        else {
                            childSection.approved = 2;
                            childSection.completeFromWeb(false);
                            childSection.status = "";
                        }
                    }
                    sections.push(childSection);
                }
            }
            return sections;
        };
        InformationRequestViewModel1.prototype.evaluateStatus = function (sectionToEvaluate) {
            if (sectionToEvaluate.status == "") {
                sectionToEvaluate.approved = 0;
                sectionToEvaluate.completeFromWeb(false);
            }
            else if (sectionToEvaluate.status == "Approved") {
                sectionToEvaluate.approved = 1;
                sectionToEvaluate.completeFromWeb(true);
                sectionToEvaluate.complete = true;
            }
            else if (sectionToEvaluate.status == "Incomplete") {
                sectionToEvaluate.approved = 2;
                sectionToEvaluate.completeFromWeb(false);
            }
            else if (sectionToEvaluate.status == "Not Applicable") {
                sectionToEvaluate.approved = 3;
                sectionToEvaluate.completeFromWeb(false);
            }
            return sectionToEvaluate;
        };
        InformationRequestViewModel1.prototype.sectionChanged = function (section) {
            var oldSection;
            for (var i = 0; i < this.oldSections.length; i++) {
                oldSection = this.getSection(this.oldSections[i], section.sectionGuid);
                if (oldSection != null)
                    break;
            }
            if (section != null && oldSection != null)
                if ((JSON.stringify(section.extrafields) != JSON.stringify(oldSection.extrafields)) ||
                    (JSON.stringify(section.status) != JSON.stringify(oldSection.status))) {
                    return true;
                }
            return false;
        };
        InformationRequestViewModel1.prototype.getSection = function (section, sectionGuid) {
            if (section.sectionGuid == sectionGuid)
                return section;
            else if (section.children != null) {
                var result = null;
                for (var i = 0; result == null && i < section.children.length; i++) {
                    result = this.getSection(section.children[i], sectionGuid);
                }
                return result;
            }
            return null;
        };
        InformationRequestViewModel1.prototype.revertChanges = function () {
            this.loadData();
        };
        InformationRequestViewModel1.prototype.refreshAPIs = function () {
            //User Story 190929:: commenting due to ui no and NI number check is not required
            //if (this.hmrcInfoModel.hasInvalidSpouseFields()) {
            //    this.showOkDialog("Invalid or missing the spouse/civil partner details. Please review the data and try again.");
            //}
            //else
            if (this.hmrcInfoModel.hasChangedSpouseInfo(this.clientInfo.Spouse)) {
                $("#dialogConfirmSaveId").modal("show");
            }
            else {
                this.checkHmrcData(this.clientGuid);
            }
        };
        InformationRequestViewModel1.prototype.exportToPdf = function () {
            var _this = this;
            var self = this;
            var clientCode = self.clientInfo.ClientCode;
            var clientGuid = self.clientGuid;
            var taxYear = self.taxYear;
            var downloadFileName = clientCode + "_" + taxYear + ".pdf";
            if (!this.displayLoading())
                this.displayLoading(true);
            this.informationrequestService.ExportToPdf(clientGuid, taxYear)
                .then(function (response) {
                if (response) {
                    var baseobject = _this.base64ToBlob(response, "application/octet-stream", 512);
                    var url = window.URL.createObjectURL(baseobject);
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = downloadFileName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    _this.displayLoading(false);
                }
                else {
                    _this.showOkDialog("Error while generating Pdf.");
                    _this.displayLoading(false);
                }
            })
                .fail(function (reason) {
                _this.showOkDialog("Error while generating Pdf.");
                _this.displayLoading(false);
            });
        };
        InformationRequestViewModel1.prototype.base64ToBlob = function (base64, mimetype, slicesize) {
            mimetype = mimetype || '';
            slicesize = slicesize || 512;
            var bytechars = atob(base64);
            var bytearrays = [];
            for (var offset = 0; offset < bytechars.length; offset += slicesize) {
                var slice = bytechars.slice(offset, offset + slicesize);
                var bytenums = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    bytenums[i] = slice.charCodeAt(i);
                }
                var bytearray = new Uint8Array(bytenums);
                bytearrays[bytearrays.length] = bytearray;
            }
            return new Blob(bytearrays, { type: mimetype });
        };
        InformationRequestViewModel1.prototype.commitToTax = function () {
            var _this = this;
            var self = this;
            var clientGuid = self.clientGuid;
            var taxYear = self.taxYear;
            var sectionsToCommit = [];
            sectionsToCommit = this.extractCheckedSection();
            if (sectionsToCommit.length > 0) {
                this.displayProcessOverlay(true);
                this.informationrequestService.CommitToTax(clientGuid, taxYear, sectionsToCommit, true).then(function (response) {
                    self.displayProcessOverlay(false);
                    if (!_this.useCloudEvents()) {
                        _this.toastDCService.constructDCToast('success', "Commit successful");
                    }
                    else {
                        _this.toastDCService.constructDCToast('info', "Sending data to Tax Return<br><br>The selected data is being sent to CCH Central to use in the Tax Return. This may take some time to complete. Please refresh to check for updates.");
                    }
                    _this.loadData();
                }).fail(function (error) {
                    var parsedError = JSON.parse(error.responseText);
                    var severity = parsedError.ExceptionMessage.includes("Tax Return is in use") || parsedError.Severity !== 1 ? 'fail' : 'info';
                    _this.toastDCService.constructDCToast(severity, "Commit failed: " + parsedError.ExceptionMessage);
                    self.displayProcessOverlay(false);
                });
                this.closeDialog();
            }
            else {
                this.toastDCService.constructDCToast('info', "Please select some data to use in the tax return.");
            }
        };
        InformationRequestViewModel1.prototype.extractCheckedSection = function () {
            var allSections = this.sections;
            var checkedSection = [];
            for (var i = 0; i < allSections.length; i++) {
                if (allSections[i].children.length > 0) {
                    for (var j = 0; j < allSections[i].children.length; j++) {
                        if (allSections[i].children[j].isChecked()) {
                            checkedSection.push(allSections[i].children[j].sectionGuid);
                        }
                        if (allSections[i].children[j].children.length > 0)
                            for (var k = 0; k < allSections[i].children[j].children.length; k++) {
                                if (allSections[i].children[j].children[k].isChecked()) {
                                    checkedSection.push(allSections[i].children[j].children[k].sectionGuid);
                                }
                            }
                    }
                }
            }
            return checkedSection;
        };
        InformationRequestViewModel1.prototype.sourceSelected = function (data, checkedSources, enableCommitToTaxButton) {
            if (data.isChecked())
                checkedSources(checkedSources() + 1);
            else if (checkedSources() > 0)
                checkedSources(checkedSources() - 1);
            if (checkedSources() > 0)
                enableCommitToTaxButton(true);
            else
                enableCommitToTaxButton(false);
            return true;
        };
        InformationRequestViewModel1.prototype.saveAndCheckHmrcData = function () {
            this.displayLoading(true);
            this.saveChanges(false);
            this.checkHmrcData(this.clientGuid);
            this.closeDialog();
        };
        InformationRequestViewModel1.prototype.checkHmrcData = function (clientGuid) {
            var _this = this;
            if (!this.displayLoading())
                this.displayLoading(true);
            this.informationrequestService.CheckHmrcToken(clientGuid)
                .then(function (response) {
                if (response) {
                    _this.hasHmrcAuthorisation(true);
                    _this.getDataFromHmrc();
                }
                else {
                    _this.showOkDialog("To access Digital Tax Account information the authorisation process must be completed for the HMRC credentials associated with this client.");
                    _this.displayLoading(false);
                }
            })
                .fail(function (reason) {
                _this.toastDCService.constructDCToast('info', reason.toString());
            });
        };
        InformationRequestViewModel1.prototype.getDataFromHmrc = function () {
            var _this = this;
            var self = this;
            var id = self.clientGuid;
            var taxYear = self.taxYear;
            if (!this.displayLoading())
                this.displayLoading(true);
            this.informationrequestService.Refresh(this.clientGuid, this.clientInfo.UTR, this.clientInfo.TaxYear, this.hmrcInfoModel.getEncodedSpouseInfo(this.clientInfo.Spouse))
                .then(function (response) {
                if (response != null) {
                    if (!_this.displayLoading())
                        _this.displayLoading(true);
                    _this.clientInfo.LatestHmrcData = response;
                    _this.clientInfo.LatestHmrcDataUpdated = new Date(Date.now());
                    _this.lastUpdatedHmrcInfo(_this.clientInfo.LatestHmrcDataUpdated.toLocaleString('en-GB'));
                    _this.hmrcInfoModel.LoadHmrcValues(response);
                    document.getElementById("info-request-hmrc-button").style.background = '#01C3C3';
                    _this.saveChanges(true);
                }
            })
                .fail(function (reason) {
            })
                .done(function () {
                _this.displayLoading(false);
            });
        };
        InformationRequestViewModel1.prototype.loadData = function (refreshState) {
            var _this = this;
            this.displayLoading(true);
            var self = this;
            self.sections = [];
            var id = self.clientGuid;
            var taxYear = self.taxYear;
            this.informationrequestService.GetClientDetails(id, taxYear)
                .then(function (response) {
                if (response != null) {
                    self.hasInformationReq(true);
                    self.useCloudEvents(response.useCloudEvents);
                    self.displayMessageFeatureInDDR(response.displayMessageFeatureInDDR);
                    _this.parseData(self, response);
                    _this.createiServeCrumb();
                    _this.hmrcInfoModel.Load(response.hmrcData, response.spouseFromPT, response.spouse, _this.currentYearHeader);
                    if (_this.clientInfo.LatestHmrcData != null) {
                        _this.hmrcInfoModel.LoadHmrcValues(_this.clientInfo.LatestHmrcData);
                        _this.lastUpdatedHmrcInfo(new Date(Date.parse(_this.clientInfo.LatestHmrcDataUpdated.toString())).toLocaleString('en-GB'));
                    }
                    else if (_this.clientInfo.Received != null) {
                        _this.lastUpdatedHmrcInfo(new Date(Date.parse(_this.clientInfo.Received.toString())).toLocaleString('en-GB'));
                    }
                    _this.applyAmountFormat();
                    _this.displayLoading(false);
                    if (_this.useCloudEvents()) {
                        _this.informationrequestService.GetReturnStatus(id, taxYear)
                            .then(function (returnStatus) {
                            if (returnStatus != null) {
                                _this.lastReturnModifiedDate(new Date(Date.parse(returnStatus.lastModifiedDateString.toString())).toLocaleString('en-GB'));
                                _this.commitStatus(returnStatus.statusMessage);
                                _this.commitToTaxToastMessage(returnStatus.toastMessage);
                                _this.commitState(returnStatus.state);
                                if (refreshState && !String.isNullOrEmpty(_this.commitToTaxToastMessage())) {
                                    _this.toastDCService.constructDCToast(_this.commitState().toLocaleLowerCase(), _this.commitToTaxToastMessage());
                                }
                                if (String.isNullOrEmpty(_this.commitToTaxToastMessage())) {
                                    _this.displayCommitStatus(false);
                                }
                                else {
                                    _this.displayCommitStatus(true);
                                }
                            }
                        });
                    }
                }
            }, function (status) {
                console.log(status);
            });
            this.enableCommitToTaxButton(false);
        };
        InformationRequestViewModel1.prototype.refreshData = function () {
            this.loadData(true);
        };
        InformationRequestViewModel1.prototype.applyAmountFormat = function () {
            $('.currencyAmount').inputmask("numeric", {
                radixPoint: ".",
                groupSeparator: ",",
                digits: 2,
                autoGroup: true,
                //prefix: '£ ',
                rightAlign: false,
                undoOnEscape: true,
                integerDigits: 14
            });
            //$('.currencyAmount').attr('maxlength', 20);
            //$('#currencyAmount').on('input', function () {
            //    if ($('#currencyAmount').text.toString().indexOf('.') == -1)
            //        $('#currencyAmount').attr('maxlength', 20);
            //    else
            //        $('#currencyAmount').attr('maxlength', 23);
            //});
        };
        InformationRequestViewModel1.prototype.parseData = function (vm, response) {
            this.parseClient(vm, response);
            vm.clientInfo.Sections = this.constructSections(response.sections);
            for (var i = 0; i < vm.clientInfo.Sections.length; i++)
                vm.sections.push(vm.clientInfo.Sections[i]);
            //vm.sections = vm.clientInfo.Sections.slice();
            var old = Object.create(vm.clientInfo.Sections);
            vm.oldSections = ko.toJS(old);
        };
        InformationRequestViewModel1.prototype.shouldShowCheckbox = function (name) {
            switch (name) {
                case 'UK Bank Interest Paid Gross':
                case 'UK Interest':
                case 'Employment Income':
                //case 'Foreign Dividend Income':
                case 'National Savings Interest Paid Gross':
                case 'National Savings Interest':
                //case 'Other UK Interest Paid Gross':
                //case 'UK Unit Trust Interest Paid Gross':
                case 'Pension Income':
                case 'Foreign Pension Income':
                case 'State Benefits Income':
                case 'Foreign State Benefit Income':
                case 'Income from UK Property':
                case 'Income from Foreign Property':
                case 'Child Benefit':
                    return true;
                default: return false;
            }
        };
        InformationRequestViewModel1.prototype.taxDeductionVisible = function (name) {
            switch (name) {
                case "National Savings Interest":
                case "Other UK Interest Paid Gross":
                case "UK Investment Income":
                case "UK Interest":
                case "UK Unit Trust Interest Paid Gross":
                //case 'State Benefits Income': below section are child sections
                case "Contribution-based Employment & Support Allowance":
                case "Industrial Death Benefit":
                case "Bereavement Allowance":
                case "Statutory Adoption Pay":
                case "Statutory Paternity Pay":
                case "Statutory Sick Pay":
                case "Jobseeker's Allowance":
                case "Widowed Parent Allowance":
                case "State Retirement Pension":
                case "Carer's Allowance":
                    return false;
                default: return true;
            }
        };
        InformationRequestViewModel1.prototype.constructSections = function (responseSections, sourceName) {
            if (sourceName === void 0) { sourceName = null; }
            var sections = new Array();
            if (responseSections.length > 0)
                for (var i = 0; i < responseSections.length; i++) {
                    var childSection = new VM.BaseSectionVM();
                    childSection = this.parseSection(responseSections[i]);
                    if (childSection.parentGuid == null)
                        sourceName = childSection.name;
                    if (this.shouldShowCheckbox(sourceName))
                        childSection.checkboxVisible = true;
                    else
                        childSection.checkboxVisible = false;
                    if (sourceName == "State Benefits Income")
                        childSection.isTaxDeductionVisible = this.taxDeductionVisible(childSection.name);
                    else
                        childSection.isTaxDeductionVisible = this.taxDeductionVisible(sourceName);
                    childSection.hasWarningMissingFName(true);
                    if (childSection.status != undefined && childSection.status != "Approved")
                        childSection.completeFromWeb(false);
                    var children = this.constructSections(responseSections[i].children, sourceName);
                    childSection.children = children;
                    if (childSection.isParent || childSection.children.length > 0) {
                        var approvedChildSections = childSection.children.filter(function (e) {
                            return e.status == "Approved";
                        });
                        var notApplicableChildSections = childSection.children.filter(function (e) {
                            return e.status == "Not Applicable";
                        });
                        var childSectionsCount = childSection.children.length;
                        var approvedChildSectionsCount = approvedChildSections.length;
                        var notApplicableChildSectionsCount = notApplicableChildSections.length;
                        if (approvedChildSectionsCount == childSectionsCount || (approvedChildSectionsCount + notApplicableChildSectionsCount == childSectionsCount)) {
                            if (notApplicableChildSectionsCount == childSectionsCount) {
                                childSection.completeFromWeb(false);
                                childSection.complete = false;
                            }
                            else {
                                childSection.completeFromWeb(true);
                                childSection.complete = true;
                            }
                        }
                        else {
                            var anyNotApprove = childSection.children.filter(function (e) {
                                return e.status != "Approved";
                            });
                            if (anyNotApprove.length > 0) {
                                childSection.completeFromWeb(false);
                            }
                        }
                    }
                    sections.push(childSection);
                }
            return sections;
        };
        InformationRequestViewModel1.prototype.parseClient = function (vm, response) {
            var details = new VM.InformationRequest();
            details.ClientName = response.clientName;
            details.UTR = response.utr;
            details.NINO = response.nino;
            details.Received = response.received;
            details.TaxYear = response.taxYear;
            details.LatestComments = response.latestComments;
            details.PeriodEnd = response.periodEnd;
            details.ClientCode = response.clientCode;
            details.PracticeGuid = response.practiceGuid;
            details.ClientGuid = response.clientGuid;
            details.CreatorNetworkMemberId = response.creatorNetworkMemberId;
            details.Spouse = response.spouseFromPT;
            details.SpouseFromPT = response.spouseFromPT;
            details.HmrcData = response.hmrcData;
            details.LatestHmrcData = response.latestHmrcData;
            details.LatestHmrcDataUpdated = response.latestHmrcDataUpdated;
            vm.clientInfo = details;
            this.currentYearHeader = (details.TaxYear - 1).toString() + '/' + details.TaxYear.toString().substring(2, 4);
        };
        InformationRequestViewModel1.prototype.parseSection = function (responseSection) {
            // load sections
            return this.loadSection(responseSection);
        };
        InformationRequestViewModel1.prototype.loadSection = function (responseSection) {
            var section = new VM.SectionVM();
            section.name = responseSection.name;
            section.nameId = section.name.replace(/ /g, '');
            if (responseSection.previousYear == null) {
                section.lastyear = this.noValueLabel;
                section.hasLastYearValue = false;
            }
            else if (responseSection.previousYear == 0) {
                section.lastyear = this.exceptionsMessage;
            }
            else {
                section.lastyear = responseSection.previousYear.toFixed(2);
                section.hasLastYearValue = true;
            }
            section.parentGuid = responseSection.parentGuid;
            section.sectionGuid = responseSection.sectionGuid;
            section.clientGuid = responseSection.clientGuid;
            section.taxYear = responseSection.taxYear;
            if (responseSection.committedDate != null) {
                section.committed_Date(new Date(Date.parse(responseSection.committedDate.toString())).toLocaleDateString('en-GB'));
            }
            section.extrafields = responseSection.extraFields;
            //if (responseSection.extraFields.alias == "DefaultExtraFields" || responseSection.extraFields.alias == "Employment" ||
            //    responseSection.extraFields.alias == "JointlyOwned" || responseSection.extraFields.alias == "JointlyOwnedForeignIncome"
            //    || responseSection.extraFields.alias == "LandAndProperty"
            //    || responseSection.extraFields.alias == "ForeignIncome") {
            //    if (section.extrafields.keyValueStore.currentYear != null)
            //        section.extrafields.keyValueStore.currentYear = parseFloat(section.extrafields.keyValueStore.currentYear).toFixed(2);
            //    if (section.extrafields.keyValueStore.taxDeducted != null)
            //        section.extrafields.keyValueStore.taxDeducted = parseFloat(section.extrafields.keyValueStore.taxDeducted).toFixed(2);
            //}
            if (section.extrafields.keyValueStore.currentYear != null)
                section.extrafields.keyValueStore.currentYear = parseFloat(section.extrafields.keyValueStore.currentYear).toFixed(2);
            if (section.extrafields.keyValueStore.taxDeducted != null)
                section.extrafields.keyValueStore.taxDeducted = parseFloat(section.extrafields.keyValueStore.taxDeducted).toFixed(2);
            if (responseSection.extraFields.alias == "Employment") {
                if (section.extrafields.keyValueStore.payeReference != null) {
                    section.extrafields.keyValueStore.payeReference = section.extrafields.keyValueStore.payeReference.toString();
                }
                if (section.extrafields.keyValueStore.cypayeReference == null)
                    section.extrafields.keyValueStore.cypayeReference = section.extrafields.keyValueStore.payeReference != null ? section.extrafields.keyValueStore.payeReference : "";
            }
            if (responseSection.extraFields.keyValueStore.templateBody == "ChildBenefitBody") {
                if (section.extrafields.keyValueStore.currentYear != null)
                    section.extrafields.keyValueStore.currentYear = parseFloat(section.extrafields.keyValueStore.currentYear.toString().replace(/,/g, '')).toFixed(2);
                if (section.extrafields.keyValueStore.numberOfChildren != null)
                    section.extrafields.keyValueStore.numberOfChildren = Math.round(parseFloat(section.extrafields.keyValueStore.numberOfChildren));
                if (section.extrafields.keyValueStore.prevYearNumberOfChildren != null)
                    section.extrafields.keyValueStore.prevYearNumberOfChildren = Math.round(parseFloat(section.extrafields.keyValueStore.prevYearNumberOfChildren));
            }
            if (responseSection.extraFields.alias == "JointlyOwned" || responseSection.extraFields.alias == "JointlyOwnedForeignIncome"
                || responseSection.extraFields.alias == "LandAndProperty") {
                if (section.extrafields.keyValueStore.jointlyOwnedShare != null && section.extrafields.keyValueStore.jointlyOwnedShare != 0) {
                    section.isJointlyOwned(true);
                    section.jointShare(section.extrafields.keyValueStore.jointlyOwnedShare + '%');
                }
            }
            if (responseSection.extraFields.alias == "ForeignIncome"
                || responseSection.extraFields.alias == "JointlyOwnedForeignIncome"
                || responseSection.extraFields.alias == "LandAndProperty") {
                if (section.extrafields.keyValueStore.foreignCurrency != null) {
                    var length = section.extrafields.keyValueStore.foreignCurrency.toString().length;
                    var currency = section.extrafields.keyValueStore.foreignCurrency.toString().substring(length - 4);
                    section.foreignCurrency(currency);
                    section.foreignCountry("Country : " + section.extrafields.keyValueStore.foreignCurrency.toString().substring(0, length - 6));
                }
            }
            if (responseSection.extraFields.alias == "LandAndProperty") {
                if (section.extrafields.keyValueStore.foreignCurrency == null)
                    section.extrafields.keyValueStore.foreignCurrency = "";
                if (section.extrafields.keyValueStore.clientCategory == null)
                    section.extrafields.keyValueStore.clientCategory = "";
                if (section.extrafields.keyValueStore.rentalIncome == null || section.extrafields.keyValueStore.rentalIncome == "")
                    section.extrafields.keyValueStore.rentalIncome = "";
                else
                    section.extrafields.keyValueStore.rentalIncome = parseFloat(section.extrafields.keyValueStore.rentalIncome).toFixed(2);
                if (section.extrafields.keyValueStore.otherIncome == null || section.extrafields.keyValueStore.otherIncome == "")
                    section.extrafields.keyValueStore.otherIncome = "";
                else
                    section.extrafields.keyValueStore.otherIncome = parseFloat(section.extrafields.keyValueStore.otherIncome).toFixed(2);
                if (section.extrafields.keyValueStore.councilTax == null || section.extrafields.keyValueStore.councilTax == "")
                    section.extrafields.keyValueStore.councilTax = "";
                else
                    section.extrafields.keyValueStore.councilTax = parseFloat(section.extrafields.keyValueStore.councilTax).toFixed(2);
                if (section.extrafields.keyValueStore.waterRates == null || section.extrafields.keyValueStore.waterRates == "")
                    section.extrafields.keyValueStore.waterRates = "";
                else
                    section.extrafields.keyValueStore.waterRates = parseFloat(section.extrafields.keyValueStore.waterRates).toFixed(2);
                if (section.extrafields.keyValueStore.insurance == null || section.extrafields.keyValueStore.insurance == "")
                    section.extrafields.keyValueStore.insurance = "";
                else
                    section.extrafields.keyValueStore.insurance = parseFloat(section.extrafields.keyValueStore.insurance).toFixed(2);
                if (section.extrafields.keyValueStore.groundRent == null || section.extrafields.keyValueStore.groundRent == "")
                    section.extrafields.keyValueStore.groundRent = "";
                else
                    section.extrafields.keyValueStore.groundRent = parseFloat(section.extrafields.keyValueStore.groundRent).toFixed(2);
                if (section.extrafields.keyValueStore.repairs == null || section.extrafields.keyValueStore.repairs == "")
                    section.extrafields.keyValueStore.repairs = "";
                else
                    section.extrafields.keyValueStore.repairs = parseFloat(section.extrafields.keyValueStore.repairs).toFixed(2);
                if (section.extrafields.keyValueStore.mortgageInterest == null || section.extrafields.keyValueStore.mortgageInterest == "")
                    section.extrafields.keyValueStore.mortgageInterest = "";
                else
                    section.extrafields.keyValueStore.mortgageInterest = parseFloat(section.extrafields.keyValueStore.mortgageInterest).toFixed(2);
                if (section.extrafields.keyValueStore.otherFinancialCosts == null || section.extrafields.keyValueStore.otherFinancialCosts == "")
                    section.extrafields.keyValueStore.otherFinancialCosts = "";
                else
                    section.extrafields.keyValueStore.otherFinancialCosts = parseFloat(section.extrafields.keyValueStore.otherFinancialCosts).toFixed(2);
                if (section.extrafields.keyValueStore.legalFees == null || section.extrafields.keyValueStore.legalFees == "")
                    section.extrafields.keyValueStore.legalFees = "";
                else
                    section.extrafields.keyValueStore.legalFees = parseFloat(section.extrafields.keyValueStore.legalFees).toFixed(2);
                if (section.extrafields.keyValueStore.managementFees == null || section.extrafields.keyValueStore.managementFees == "")
                    section.extrafields.keyValueStore.managementFees = "";
                else
                    section.extrafields.keyValueStore.managementFees = parseFloat(section.extrafields.keyValueStore.managementFees).toFixed(2);
                if (section.extrafields.keyValueStore.otherProfessionalCosts == null || section.extrafields.keyValueStore.otherProfessionalCosts == "")
                    section.extrafields.keyValueStore.otherProfessionalCosts = "";
                else
                    section.extrafields.keyValueStore.otherProfessionalCosts = parseFloat(section.extrafields.keyValueStore.otherProfessionalCosts).toFixed(2);
                if (section.extrafields.keyValueStore.costsOfServicesProvided == null || section.extrafields.keyValueStore.costsOfServicesProvided == "")
                    section.extrafields.keyValueStore.costsOfServicesProvided = "";
                else
                    section.extrafields.keyValueStore.costsOfServicesProvided = parseFloat(section.extrafields.keyValueStore.costsOfServicesProvided).toFixed(2);
                if (section.extrafields.keyValueStore.wages == null || section.extrafields.keyValueStore.wages == "")
                    section.extrafields.keyValueStore.wages = "";
                else
                    section.extrafields.keyValueStore.wages = parseFloat(section.extrafields.keyValueStore.wages).toFixed(2);
                if (section.extrafields.keyValueStore.otherPropertyExpenses == null || section.extrafields.keyValueStore.otherPropertyExpenses == "")
                    section.extrafields.keyValueStore.otherPropertyExpenses = "";
                else
                    section.extrafields.keyValueStore.otherPropertyExpenses = parseFloat(section.extrafields.keyValueStore.otherPropertyExpenses).toFixed(2);
                section.RentalIncome(section.extrafields.keyValueStore.rentalIncome);
                section.OtherIncome(section.extrafields.keyValueStore.otherIncome);
                section.CouncilTax(section.extrafields.keyValueStore.councilTax);
                section.WaterRates(section.extrafields.keyValueStore.waterRates);
                section.Insurance(section.extrafields.keyValueStore.insurance);
                section.GroundRent(section.extrafields.keyValueStore.groundRent);
                section.Repairs(section.extrafields.keyValueStore.repairs);
                section.MortgageInterest(section.extrafields.keyValueStore.mortgageInterest);
                section.OtherFinancialCosts(section.extrafields.keyValueStore.otherFinancialCosts);
                section.LegalFees(section.extrafields.keyValueStore.legalFees);
                section.ManagementFees(section.extrafields.keyValueStore.managementFees);
                section.OtherProfessionalCosts(section.extrafields.keyValueStore.otherProfessionalCosts);
                section.CostsOfServicesProvided(section.extrafields.keyValueStore.costsOfServicesProvided);
                section.Wages(section.extrafields.keyValueStore.wages);
                section.OtherPropertyExpenses(section.extrafields.keyValueStore.otherPropertyExpenses);
            }
            section.complete = responseSection.complete;
            section.templateHeader = responseSection.extraFields.keyValueStore.templateHeader;
            section.templateBody = responseSection.extraFields.keyValueStore.templateBody;
            section.hasNotification(responseSection.hasNotification);
            section.hasClientNotification = responseSection.hasClientNotification;
            section.hasClientNotification = false;
            section.commentsCount(responseSection.commentsCount);
            section.attachmentsCount(responseSection.attachmentsCount);
            section.isParent = responseSection.isParent;
            if (!responseSection.isParent) {
                section.isAllowanceChanged = responseSection.extraFields.keyValueStore.hasChanged;
                if (section.isAllowanceChanged)
                    section.isAllowanceChangedDescription = "Changed";
                else
                    section.isAllowanceChangedDescription = "No Changes";
                if (responseSection.latestComment != null) {
                    section.latestComment = responseSection.latestComment.message;
                }
                else {
                    section.latestComment = "...";
                }
                var status = responseSection.approved;
                if (status == 0)
                    section.status = "";
                else if (status == 1)
                    section.status = "Approved";
                else if (status == 2)
                    section.status = "Incomplete";
                else if (status == 3)
                    section.status = "Not Applicable";
                if (responseSection.extraFields.alias == 'NewSource' && responseSection.extraFields.keyValueStore.details != null) {
                    if (responseSection.extraFields.keyValueStore.details.length > 125) {
                        section.shortDetails = responseSection.extraFields.keyValueStore.details.slice(0, 125) + "...";
                        section.togleDetails = true;
                    }
                    else
                        section.shortDetails = responseSection.extraFields.keyValueStore.details;
                }
            }
            else {
                if (responseSection.extraFields.alias == "Employment") {
                    section.hasHMRCAPI404Error(false);
                    section.hasHMRCAPIError(false);
                    if (this.clientInfo.HmrcData.apiErrors != null &&
                        this.clientInfo.HmrcData.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.EmploymentSectionName)]) {
                        var error = this.clientInfo.HmrcData.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.EmploymentSectionName)][0];
                        if (error.statusCode == 404) {
                            section.hasHMRCAPI404Error(true);
                        }
                        else {
                            section.hasHMRCAPIError(true);
                        }
                    }
                }
            }
            return section;
        };
        InformationRequestViewModel1.prototype.togleDetailsText = function (section, event) {
            section.seeMore(!section.seeMore());
        };
        InformationRequestViewModel1.prototype.setViewBreakdown = function (section, event) {
            section.viewBreakdown(!section.viewBreakdown());
        };
        InformationRequestViewModel1.prototype.expandAll = function () {
            var self = this;
            for (var i = 0; i < self.clientInfo.Sections.length; i++) {
                if (self.clientInfo.Sections[i].hasNotification()) {
                    self.clientInfo.Sections[i].hasNotification(false);
                    this.informationrequestService.clearNotification(self.clientInfo.Sections[i].clientGuid, self.clientInfo.Sections[i].taxYear, self.clientInfo.Sections[i].sectionGuid).then(function (response) { });
                }
                self.clientInfo.Sections[i].expanded(true);
            }
            for (var i = 0; i < self.hmrcInfoModel.sections.length; i++)
                if (self.hmrcInfoModel.sections[i].showChevron()) {
                    self.hmrcInfoModel.sections[i].expanded(true);
                }
            $('#childBenefitDateCeased').kendoDatePicker({ format: 'dd/MM/yyyy' });
        };
        InformationRequestViewModel1.prototype.collapseAll = function () {
            var self = this;
            for (var i = 0; i < self.clientInfo.Sections.length; i++)
                self.clientInfo.Sections[i].expanded(false);
            for (var i = 0; i < self.hmrcInfoModel.sections.length; i++)
                self.hmrcInfoModel.sections[i].expanded(false);
        };
        InformationRequestViewModel1.prototype.showInformation = function (section, event) {
            console.log("show");
        };
        InformationRequestViewModel1.prototype.showCommitViewMore = function () {
            this.toastDCService.constructDCToast(this.commitState().toLowerCase(), this.commitToTaxToastMessage());
        };
        InformationRequestViewModel1.prototype.errorClicked = function (section) {
            var self = this;
            self.showErrors(section.name);
        };
        InformationRequestViewModel1.prototype.showErrors = function (sectionName) {
            var hmrcInfo = this.clientInfo.HmrcData;
            if (hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionName)]) {
                var error404Description = sectionName;
                var has500Error = false;
                var has404Error = false;
                for (var i = 0; i < hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionName)].length; i++) {
                    var error = hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionName)][i];
                    var toastMessage = this.ConstructToastMessage(sectionName, error);
                    if (error.statusCode == 400 || error.statusCode == 401)
                        this.toastDCService.constructDCToast('fail', toastMessage);
                    if (error.statusCode == 404) {
                        if (error.aPIName != null)
                            error404Description = error404Description + " <br> - " + error.aPIName;
                        else
                            error404Description = error404Description;
                        has404Error = true;
                    }
                    if (error.statusCode == 500) {
                        has500Error = true;
                    }
                }
                if (has404Error)
                    this.toastDCService.constructDCToast('success', "Sorry! No data currently held by HMRC : <br>" + error404Description);
                if (has500Error)
                    this.toastDCService.constructDCToast('fail', "Server Error : Internal server error");
            }
        };
        InformationRequestViewModel1.prototype.ConstructToastMessage = function (sectionName, error) {
            var errorMessage = "";
            if (error.aPIName != null && error.aPIName.length > 0) {
                errorMessage = sectionName + " : " + error.aPIName + " - " + error.reasonPhrase + " : " + error.errorDescription;
            }
            else {
                errorMessage = sectionName + " : " + error.reasonPhrase + " - " + error.errorDescription;
            }
            return errorMessage;
        };
        return InformationRequestViewModel1;
    }(common.ListViewModelBase));
    var instance = new InformationRequestViewModel1();
    return instance;
});

